// JS

import './js/journeys/get-a-mortgage/main.js';

// Images

import './img/journeys/get-a-mortgage/buyToLetIcon.svg';
import './img/journeys/get-a-mortgage/houseIcon.svg';
import './img/journeys/get-a-mortgage/movingIcon.svg';
import './img/journeys/get-a-mortgage/remortgageIcon.svg';